import React, { useState, useContext } from 'react';

import { AccountContext } from '../../../auth/Accounts';
import API from '../../../../api';
import Loader from '../../../Loading';
import { withSnackbar } from '../../../HOC/Alert';

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

function RefreshAPIKeyModal(props) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const { getSession } = useContext(AccountContext);

    const handleClose = () => {
        setUsername("");
        setPassword("");
        props.onHide();
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        getSession()
            .then(session => {
                setLoading(true);
                API.post("/org_settings/wint/refresh",
                    { username, password },
                    {
                        headers: { "Authorization": session.idToken.jwtToken },
                        params: { org_name: session.idToken.payload.name }
                    }
                )
                    .then(() => {
                        setLoading(false);
                        handleClose();
                        props.onSuccess();
                    })
                    .catch(err => {
                        setLoading(false);
                        const message = err.response?.data?.detail || "Failed to refresh API key";
                        props.showAlert(message, "error");
                    })
            })
    }

    return (
        <Modal
            show={props.show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header>
                <Modal.Title>Refresh API Key</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {loading ? <Loader /> :
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="ptUsername">
                            <TextField
                                size="small"
                                label="Username"
                                variant="outlined"
                                required
                                fullWidth
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group controlId="ptPassword">
                            <TextField
                                size="small"
                                label="Password"
                                type="password"
                                variant="outlined"
                                required
                                fullWidth
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Form.Group>
                        <Modal.Footer>
                            <Button variant="contained" color="info" onClick={handleClose} className="mr-3">Cancel</Button>
                            <Button variant="contained" color="primary" type="submit">Submit</Button>
                        </Modal.Footer>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}

export default withSnackbar(RefreshAPIKeyModal);
